import { render, staticRenderFns } from "./AnaliseReceita.vue?vue&type=template&id=28ee0397&scoped=true&"
import script from "./AnaliseReceita.vue?vue&type=script&lang=js&"
export * from "./AnaliseReceita.vue?vue&type=script&lang=js&"
import style0 from "./AnaliseReceita.vue?vue&type=style&index=0&id=28ee0397&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ee0397",
  null
  
)

export default component.exports